import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner,finishSpinner } from "../ui/spinner";
import { filterArrayFromArray, filterMultipleCondition } from "../../helpers/extraFunctions";

export const efectoresPTraerStart = () => ({ type: types.efectoresPTraerStart });
export const efectoresPLimpiar = () => ({ type: types.efectoresPLimpiar });
export const efectoresPTraerError = (error) => ({ type: types.efectoresPTraerError,payload: error});
export const efectoresPTraerSuccess = (payload) => {
  return {
    type: types.efectoresPTraerSuccess,
    payload: payload
  }
}
export const efectoresPsetOrDeleteSobreturnos = (payload) => {
    return {
        type: types.efectoresPsetOrDeleteSobreturnos,
        payload: payload
    }
}

export const fetchEfectoresP = () => {
    return async (dispatch) => {
      try{
        dispatch(startSpinner());
        dispatch(efectoresPTraerStart());
        const response = await fetchConToken(`EfectorP`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (response.status !== 200) throw lista.errores;
          dispatch( efectoresPTraerSuccess(lista) );
        }
        dispatch(finishSpinner());
      } catch (err){
        dispatch(finishSpinner());
        dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
};

export const fetchEfectoresPPorUsuario = (conEspecialidad = null, edadAfiliado = null) => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(efectoresPTraerStart());
      const response = conEspecialidad
                          ?
                            await fetchConToken(`EfectorP/traerPorUsuarioConEspecialidad${edadAfiliado ? `?edadAfiliado=${edadAfiliado}` : ''}`)
                          :
                            await fetchConToken(`EfectorP/traerPorUsuario`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch( efectoresPTraerSuccess(lista) );
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const setOrDeleteMedicoSobreturno = (idEfectorP, idCentroMedico, idEspecialidad, set = false) => {
    return async (dispatch, getState) => {
        try{
            dispatch(startSpinner());
            dispatch(efectoresPTraerStart());
            const response = await fetchConToken(`EfectorPSobreturnos`, {idEfectorP, idCentroMedico, idEspecialidad}, set ? "POST" : "DELETE");
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const resp = await response.json();
                if (!response.ok) throw resp.errores;
                
                const state = getState();
                const filterArguments = { idCentroMedico: idCentroMedico, idEspecialidad: idEspecialidad };
                const { configuracionSobreturnos: configActual } = state.efectoresP.items.find(s => s.idEfectorRed === idEfectorP);
                if(set){
                  const nuevaConfig = [ ...filterArrayFromArray(configActual, filterMultipleCondition(configActual, filterArguments)), resp ];
                  dispatch( efectoresPsetOrDeleteSobreturnos({idEfectorP, nuevaConfig}) );
                }else {
                  const nuevaConfig = [ ...filterArrayFromArray(configActual, filterMultipleCondition(configActual, filterArguments)) ];
                  dispatch( efectoresPsetOrDeleteSobreturnos({idEfectorP, nuevaConfig}) );
                }
                dispatch(finishSpinner()); 
            }
        } catch (err) {
            console.log( err );
            dispatch(finishSpinner());
            dispatch(startAlerta(err, "warning", `¡Error!`));
        }
    }; 
};